const GlobalConfig = function () {
  let _payDomain = 'https://new-m.pay.naver.com';
  let _stockDomain = 'https://m.stock.naver.com';
  let _realEstateDomain = 'https://m.land.naver.com';
  let _insuranceDomain = 'https://insurance.pay.naver.com';
  return {
    get payDomain() {
      return _payDomain;
    },
    setPayDomain(domain) {
      _payDomain = domain;
    },
    get stockDomain() {
      return _stockDomain;
    },
    setStockDomain(domain) {
      _stockDomain = domain;
    },
    get realEstateDomain() {
      return _realEstateDomain;
    },
    setRealEstateDomain(domain) {
      _realEstateDomain = domain;
    },
    get insuranceDomain() {
      return _insuranceDomain;
    },
    setInsuranceDomain(domain) {
      _insuranceDomain = domain;
    }
  };
}();

export { GlobalConfig };
